import React from "react";
import { TbChevronsLeft } from "react-icons/tb";
import { createSearchParams, Link, useNavigate } from "react-router-dom";
import { useReserve } from "../Hooks";
import Card from "./Card";
import CustomSlider from "./CustomSlider";
const Reserve = ({
  title,
  description,
  data,
  loading,
  city: { id, name, slug },
  category = false,
}) => {
  const { renderCategory, navigate, renderCity } = useReserve();

  //
  if (data.length < 4) {
    return <></>;
  }
  return (
    <>
      <div className="card-shadow-web mb-4 reserve-box">
        <div className="reserve-title">
          <div className="reserve-subtitle" style={{}}>
            <div>
              {" "}
              <h5 style={{ color: "#E42A3F" }}>
                <img
                  src={window.origin + `/WebSide/assets/images/${99}.png`}
                  alt="رزرو"
                  style={{
                    width: "40px",
                    height: "40px",
                    marginLeft: "10px",
                  }}
                />
                {renderCategory(name)["title"]}
              </h5>
            </div>
            <div className="reserve-show-all d-flex align-items-center">
              <span
                style={{ cursor: "pointer" }}
                onClick={() => {
                  if (category) {
                    navigate(slug);
                  } else {
                    navigate(slug);
                  }
                }}
              >
                مشاهده همه
              </span>
              <TbChevronsLeft size={"1.4rem"} />
            </div>
          </div>
          <hr style={{ color: "rgb(228, 42,63)" }} />
          <p></p>
        </div>
        <div>
          <h3>{title}</h3>
        </div>

        <p>{description}</p>

        <div>
          <CustomSlider
            data={data}
            renderCard={(data, count) => {
              return <Card data={data} key={count} />;
              // return <Card2 data={data} />;
            }}
            isReserve={true}
            numbers={4}
          />{" "}
        </div>
      </div>
    </>
  );
};

export default Reserve;
